var _clipPath, _clipPath2, _clipPath3, _clipPath4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 0h-400v300h400z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 300h-400v179.996h400z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 300h-400v179.996h400z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 50c0-27.6172-22.383-50-50-50h-300c-27.6172 0-50 22.3828-50 50v380c0 27.613 22.3828 50 50 50h240l110-110z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.13333333 0 0 -.13333333 0 64)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.93l107.07-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 480h-240c-27.6172 0-50-22.387-50-50v-380c0-27.6172 22.3828-50 50-50h300c27.617 0 50 22.3828 50 50v320zm-4.141-10 104.141-104.141v-315.859c0-22.0625-17.937-40-40-40h-300c-22.0586 0-40 17.9375-40 40v380c0 22.055 17.9414 40 40 40z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.93l107.07-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#efbe2c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 480h-240c-27.6172 0-50-22.387-50-50v-380c0-27.6172 22.3828-50 50-50h300c27.617 0 50 22.3828 50 50v320zm-4.141-10 104.141-104.141v-315.859c0-22.0625-17.937-40-40-40h-300c-22.0586 0-40 17.9375-40 40v380c0 22.055 17.9414 40 40 40z",
    fill: "#e0ad1f"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m344.355 384.973 96.79-96.793v96.793z",
    fill: "#e0ad1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 370h-60c-27.617 0-50 22.387-50 50v60h110z",
    fill: "#f5d576"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m96.5938 417.699h41.8362l-26.028-45.746h25.098v-11.953h-44.3359l26.1839 45.836h-22.7542z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.695 417.699h12.442v-57.699h-12.442z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.133 407.328v-14.765h4.832c2.082 0 3.855.746 5.344 2.242 1.472 1.492 2.214 3.265 2.214 5.316 0 2.344-.839 4.16-2.5 5.449-1.679 1.289-4.043 1.934-7.128 1.934zm-12.18 10.371h19.735c5.304 0 9.582-1.547 12.832-4.633 3.253-3.093 4.875-7.156 4.875-12.199 0-3.308-.801-6.453-2.391-9.422-1.594-2.976-4.008-5.195-7.231-6.66-3.218-1.465-5.972-2.226-8.257-2.285l-7.207-.176v-22.324h-12.356z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e0e0e0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m330 0h-60v40h60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300 40h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 70h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300 100h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 130h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.992 300h-47.996l-19.758-59.273c-4.683-14.055-2.332-29.516 6.328-41.547 8.664-12.032 22.59-19.168 37.414-19.18h.02c14.824 0 28.75 7.129 37.41 19.148 8.676 12.036 11.028 27.493 6.34 41.555z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m280 230c0 11.047 8.953 20 20 20s20-8.953 20-20-8.953-20-20-20-20 8.953-20 20",
    fill: "#f6f6f6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.8d0f1a351d979692bcb97c77def8d9ff.svg";
export { ForwardRef as ReactComponent };